  <p-drawer
    [visible]="true"
    position="left"
    [modal]="false"
    [dismissible]="false"
    [blockScroll]="false"
    [showCloseIcon]="false"
    [styleClass]="isCollapsed ? 'sidebar-drawer collapsed' : 'sidebar-drawer'"
  >

    <ng-template pTemplate="header">
      <div class="sidebar-header">
        <img
          src="/header/png/Ribera_logo_color.svg"
          alt="logo"
          *ngIf="!isCollapsed"
        />

        <p-button
          aria-label="button collapse"
          variant="outlined"
          severity="secondary"
          icon="pi pi-angle-left"
          class="toggle-btn"
          (click)="toggleSidebar()"
          [class.rotated]="isCollapsed"
        />
      </div>
    </ng-template>

    @for (item of filteredMenu(); track $index) {
    <div class="section-items">
      <span class="section-title" >{{item.title}}</span>
      <ul class="menu">
        @for (subItem of item.items; track $index) {
          <li [routerLinkActiveOptions]="{ exact: false }" [routerLinkActive]="subItem.route ? 'active-link' : ''"
          >
            <a [routerLink]="subItem.route" class="icon_label" 
            (click)="isCollapsed? subItem.children && popover.toggle($event) : subItem.children && toggleSubmenu(subItem.id)"
            pTooltip="{{ subItem.label }}"
            tooltipPosition="right"
            [tooltipDisabled]="!isCollapsed"
            tooltipStyleClass="sidebar-tooltip"
            >
              <img [src]="subItem.icon" alt="" class="menu-icon" [routerLinkActive]="subItem.route ? 'active-link' : ''">
              <span [ngStyle]="{'display': isCollapsed ? 'none' : 'flex'}" *ngIf="!isCollapsed">{{subItem.label}}</span>
            </a>
          @if (isCollapsed === false) {
            @if (subItem.children) {
              <div>
                <button class="toggle-submenu" (click)="toggleSubmenu(subItem.id)">
                  <img [src]="subItem.expanded ? '/sidebar/arrow-up.svg' : '/sidebar/arrow-down.svg'" alt="Toggle Submenu" class="icon icon-menu"/>
                </button>
              </div>
            }
          }
          </li>
          
            <ul class="submenu" [class.show]="subItem.expanded && !isCollapsed">
              @for (child of subItem.children; track $index) {
                <li [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active-link">
                  <a [routerLink]="child.route" class="icon_label" >
                    <div class="submenu-labels" [ngStyle]="{'display': isCollapsed ? 'none' : 'flex'}" *ngIf="!isCollapsed">
                      <span>{{child.label}}</span>
                      <small *ngIf="child.subLabel">{{ child.subLabel }}</small>
                    </div>
                  </a>
                </li>
              }
            </ul>
          
          
          <p-popover #popover styleClass="sidebar-popover">
          <ul class="submenu-float">
            @for (child of subItem.children; track $index) {
              <li>
                <a
                  [routerLink]="child.route"
                  (click)="popover.hide()"
                >
                  {{ child.label }}
                </a>
              </li>
            }
          </ul>
        </p-popover>
        }
      </ul>
    </div>
    }

    <ng-template pTemplate="footer">
      <a class="sidebar-footer" (click)="onLogout()">
        <i class="pi pi-sign-out"></i>
        <span *ngIf="!isCollapsed">Cerrar sesión</span>
      </a>
    </ng-template>

  </p-drawer>

  <p-drawer
    [visible]="mobileMenuVisible"
    (visibleChange)="mobileMenuVisible = $event"
    position="left"
    [modal]="true"
    [dismissible]="true"
    [blockScroll]="true"
    [showCloseIcon]="false"
    styleClass="mobile-sidebar-drawer"
  >
    <ng-template pTemplate="header">
      <div class="sidebar-header mobile-sidebar-header">
        <img src="/header/png/Ribera_logo_color.svg" alt="logo" />

        <button
          type="button"
          class="mobile-close-btn"
          (click)="closeMobileMenu()"
          aria-label="Cerrar menú"
        >
          <img src="/header/png/close-icon.png" alt="" />
        </button>
      </div>
    </ng-template>

    @for (item of filteredMenu(); track $index) {
      <div class="section-items mobile-section-items">
        <span class="section-title">{{ item.title }}</span>
        <ul class="menu mobile-menu">
          @for (subItem of item.items; track $index) {
            <li [routerLinkActiveOptions]="{ exact: false }" routerLinkActive="active-link">
              <a
                [routerLink]="subItem.route ?? null"
                class="icon_label"
                (click)="onMobileSidebarItemClick($event, subItem)"
              >
                <img [src]="subItem.icon" alt="" class="menu-icon" routerLinkActive="active-link">
                <span>{{ subItem.label }}</span>
              </a>

              @if (subItem.children) {
                <button type="button" class="toggle-submenu" (click)="toggleSubmenu(subItem.id)">
                  <img
                    [src]="subItem.expanded ? '/sidebar/arrow-up.svg' : '/sidebar/arrow-down.svg'"
                    alt="Toggle Submenu"
                    class="icon icon-menu"
                  />
                </button>
              }
            </li>

            <ul class="submenu" [class.show]="subItem.expanded">
              @for (child of subItem.children; track $index) {
                <li>
                  <a [routerLink]="child.route" class="icon_label" (click)="closeMobileMenu()">
                    <div class="submenu-labels">
                      <span>{{ child.label }}</span>
                      <small *ngIf="child.subLabel">{{ child.subLabel }}</small>
                    </div>
                  </a>
                </li>
              }
            </ul>
          }
        </ul>
      </div>
    }

    <ng-template pTemplate="footer">
      <a class="sidebar-footer" (click)="onLogout()">
        <i class="pi pi-sign-out"></i>
        <span>Cerrar sesión</span>
      </a>
    </ng-template>
  </p-drawer>

  <div class="content " [class.collapsed]="isCollapsed">
  </div>


